import { render, staticRenderFns } from "./announcementsListNew.vue?vue&type=template&id=106a4fa4&scoped=true"
import script from "./announcementsListNew.vue?vue&type=script&lang=js"
export * from "./announcementsListNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106a4fa4",
  null
  
)

export default component.exports